<script setup lang="ts">
import type { mastodon } from '#shared/types'

const { id } = useRoute().params
const isLoggedIn = useAuth().loggedIn

onMounted(async () => {
  if (isLoggedIn) {
    await $fetch<mastodon.v1.Status>(`/api/tags/${id}/read`, {
      method: 'POST',
    })
  }
})

const url = `/api/timelines/tag/${id}`
const channel = `timeline:tag:${id}`
</script>

<template>
  <TimelineStatuses :url="url" :channel="channel" class="grid" />
</template>
